import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './AtlasMenu.css';

// Nœuds repositionnés : plus grands, plus rapprochés, dans la zone trapézoïdale
const NODES = [
  { id: 'home',          label: 'Accueil',         cat: 'main',      r: 15, cx: 0.13, cy: 0.46 , path: '/', mobileCx: 0.4, mobileCy: 0.458 },
  { id: 'projets',       label: 'Projets',         cat: 'projets',   r: 15, cx: 0.18, cy: 0.27, path: '/projets', mobileCx: 0.6, mobileCy: 0.259 },
  { id: 'phaino',        label: 'Phaino',          cat: 'projets',   r: 15,  cx: 0.13, cy: 0.25, path: '/phaino', mobileCx: 0.4, mobileCy: 0.238 },
  { id: 'noise',         label: 'Noise',           cat: 'projets',   r: 11,  cx: 0.09, cy: 0.33, path: null, mobileCx: 0.24, mobileCy: 0.322 },
  { id: 'siloportem',    label: 'Siloportem',      cat: 'projets',   r: 11,  cx: 0.15, cy: 0.08, path: null, mobileCx: 0.48, mobileCy: 0.06 },
  { id: 'anhydran',      label: 'An·hydra·n',      cat: 'projets',   r: 15,  cx: 0.05, cy: 0.13, path: '/anhydran', mobileCx: 0.08, mobileCy: 0.112 },
  { id: 'phonemes2',     label: 'Phonèmes#2',      cat: 'projets',   r: 11,  cx: 0.26, cy: 0.14, path: '/phonemes2', mobileCx: 0.92, mobileCy: 0.123 },
  { id: 'phonemes1',     label: 'Phonèmes#1',      cat: 'projets',   r: 11,  cx: 0.22, cy: 0.18, path: '/phonemes1', mobileCx: 0.76, mobileCy: 0.165 },
  { id: 'transmutation', label: 'Transmutation',   cat: 'projets',   r: 11,  cx: 0.24, cy: 0.29, path: '/transmutation', mobileCx: 0.84, mobileCy: 0.28 },
  { id: 'flots',         label: 'Flots',           cat: 'projets',   r: 7,  cx: 0.20, cy: 0.36, path: '/flots', mobileCx: 0.68, mobileCy: 0.353 },
  { id: 'transcendance', label: 'Transcendance',   cat: 'projets',   r: 7,  cx: 0.18, cy: 0.13, path: '/transcendance', mobileCx: 0.6, mobileCy: 0.112 },
  { id: 'tina',          label: 'T.I.N.A.',        cat: 'projets',   r: 7,  cx: 0.08, cy: 0.20, path: '/tina', mobileCx: 0.2, mobileCy: 0.186 },
  { id: 'eveil',         label: 'Éveil',           cat: 'projets',   r: 7,  cx: 0.13, cy: 0.16, path: '/eveil', mobileCx: 0.4, mobileCy: 0.144 },
  { id: 'recherche',     label: 'Recherche',       cat: 'recherche', r: 15, cx: 0.10, cy: 0.70, path: '/recherche', mobileCx: 0.28, mobileCy: 0.71 },
  { id: 'atlas',         label: 'Atlas',           cat: 'recherche', r: 11,  cx: 0.16, cy: 0.70, path: '/atlas-recherche', mobileCx: 0.52, mobileCy: 0.71 },
  { id: 'labo',          label: 'Labo',            cat: 'recherche', r: 11,  cx: 0.18, cy: 0.66, path: '/laboratoire-symbiotique', mobileCx: 0.6, mobileCy: 0.668 },
  { id: 'ecoute',        label: 'Chambres d écoute',cat: 'recherche', r: 11,  cx: 0.10, cy: 0.80, path: null, mobileCx: 0.28, mobileCy: 0.814 },
  { id: 'ecoute1',       label: 'Ch.d.Ec.#1',       cat: 'recherche', r: 7,  cx: 0.10, cy: 0.92, path: '/chambre-ecoute1', mobileCx: 0.28, mobileCy: 0.94 },
  { id: 'ecoute2',       label: 'Ch.d.Ec.#2',       cat: 'recherche', r: 7,  cx: 0.15, cy: 0.86, path: '/chambre-ecoute2', mobileCx: 0.48, mobileCy: 0.877 },
  { id: 'ecouteanh',     label: 'Ch.d.Ec. de Anhydran',cat: 'recherche', r: 7,  cx: 0.05, cy: 0.88, path: '/chambre-ecoute-anhydran', mobileCx: 0.08, mobileCy: 0.898 },
  { id: 'apropos',       label: 'À propos',        cat: 'info',      r: 15,  cx: 0.20, cy: 0.45, path: '/Apropos', mobileCx: 0.68, mobileCy: 0.448 },
  { id: 'contact',       label: 'Contact',         cat: 'info',      r: 15,  cx: 0.18, cy: 0.52, path: null, mobileCx: 0.6, mobileCy: 0.521 },
  { id: 'pedagogie',     label: 'Pedagogie',       cat: 'info',      r: 11,  cx: 0.08, cy: 0.55, path: '/pedagogie', mobileCx: 0.2, mobileCy: 0.552 },
  { id: 'quatreportes', label: 'Quatre Portes', cat: 'recherche', r: 7, cx: 0.12, cy: 0.60, path: '/quatre-portes', mobileCx: 0.2, mobileCy: 0.552 }
];

const LINKS = [
  ['home','projets'],['home','recherche'],['home','apropos'],['home','contact'],['home','pedagogie'],
  ['projets','anhydran'],['projets','phonemes2'],['projets','phonemes1'],
  ['projets','transmutation'],['projets','flots'],['projets','transcendance'],
  ['projets','tina'],['projets','eveil'],['projets','phaino'],
  ['projets','noise'],['projets','siloportem'],
  ['recherche','atlas'],['recherche','labo'],['recherche','ecoute1'],
  ['recherche','ecoute2'],['recherche','ecouteanh'],['recherche','ecoute'],['recherche','noise'],
  ['ecoute','ecoute1'],['ecoute','ecoute2'],['ecoute','ecouteanh'],
  ['anhydran','ecouteanh'],
  ['apropos','contact'],
  ['pedagogie','quatreportes'],
];

const COLORS = {
  main:      '#ffffff',
  projets:   '#93d1ca',
  recherche: '#bcb5f7',
  info:      '#ffffff',
};

const AtlasMenu = ({ isOpen, onClose, onContactOpen }) => {
  const navigate   = useNavigate();
  const cvRef      = useRef(null);
  const rafRef     = useRef(null);
  const offsetsRef = useRef({});
  const hoveredRef = useRef(null);
  const [hovered, setHovered]   = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    NODES.forEach(n => {
      offsetsRef.current[n.id] = { t: Math.random() * Math.PI * 2 };
    });
  }, []);

  const resize = useCallback(() => {
    const cv = cvRef.current;
    if (!cv) return;
    const rect = cv.getBoundingClientRect();
    cv.width  = rect.width;
    cv.height = rect.height;
  }, []);

  useEffect(() => {
    window.addEventListener('resize', resize);
    resize();
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  // Draw loop
  useEffect(() => {
    const draw = () => {
      const cv = cvRef.current;
      if (!cv) { rafRef.current = requestAnimationFrame(draw); return; }
      const ctx = cv.getContext('2d');
      const W = cv.width, H = cv.height;
      if (!W || !H) { rafRef.current = requestAnimationFrame(draw); return; }

      ctx.clearRect(0, 0, W, H);
      NODES.forEach(n => { offsetsRef.current[n.id].t += 0.006; });

      const pos = {};
      const mobile = window.innerWidth <= 1024;
      NODES.forEach(n => {
        const o = offsetsRef.current[n.id];
        const cx = mobile && n.mobileCx !== undefined ? n.mobileCx : n.cx;
        const cy = mobile && n.mobileCy !== undefined ? n.mobileCy : n.cy;
        pos[n.id] = {
          x: cx * W + Math.sin(o.t) * n.r * 0.2,
          y: cy * H + Math.cos(o.t) * n.r * 0.2,
        };
      });

      const hov = hoveredRef.current;

      // Liens
      LINKS.forEach(([a, b]) => {
        const hot = hov === a || hov === b;
        ctx.beginPath();
        ctx.moveTo(pos[a].x, pos[a].y);
        ctx.lineTo(pos[b].x, pos[b].y);
        ctx.strokeStyle = hot ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255,255,255,0.15)';
        ctx.lineWidth   = hot ? 1 : 0.5;
        ctx.stroke();
      });

      // Nœuds
      NODES.forEach(n => {
        const { x, y } = pos[n.id];
        const col = COLORS[n.cat];
        const isH = hov === n.id;
        const r   = n.r * (isH ? 1.3 : 1);

        // Halo
        const g = ctx.createRadialGradient(x, y, 0, x, y, r * 3);
        g.addColorStop(0, col + '1a');
        g.addColorStop(1, 'transparent');
        ctx.beginPath(); ctx.arc(x, y, r * 3, 0, Math.PI * 2);
        ctx.fillStyle = g; ctx.fill();

        // Cercle
        ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fillStyle   = col + (isH ? 'bb' : '33');
        ctx.fill();
        ctx.strokeStyle = col + (isH ? 'ff' : '88');
        ctx.lineWidth   = isH ? 1.5 : 0.7;
        ctx.stroke();

        // Label — visible si r >= 11 ou hover
        if (n.r >= 11 || isH) {
          ctx.fillStyle = isH ? 'white' : 'rgba(255,255,255,0.55)';
          ctx.font      = `${isH ? 400 : 300} ${Math.max(12, r * 1)}px Roboto, sans-serif`;
          ctx.textAlign = 'center';
          ctx.fillText(n.label.toUpperCase(), x, y + r + Math.max(15, r * 0.85));
        }
      });

      rafRef.current = requestAnimationFrame(draw);
    };

    rafRef.current = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  const handleMouseMove = useCallback((e) => {
    if (!isOpen) return;
    const cv = cvRef.current;
    if (!cv) return;
    const rect = cv.getBoundingClientRect();
    const mx = e.clientX - rect.left;
    const my = e.clientY - rect.top;
    const W = cv.width, H = cv.height;

    const mobile = W <= 1024;
    let found = null;
    for (const n of NODES) {
      const o  = offsetsRef.current[n.id];
      const cx = mobile && n.mobileCx !== undefined ? n.mobileCx : n.cx;
      const cy = mobile && n.mobileCy !== undefined ? n.mobileCy : n.cy;
      const nx = cx * W + Math.sin(o.t) * n.r * 0.2;
      const ny = cy * H + Math.cos(o.t) * n.r * 0.2;
      if (Math.hypot(mx - nx, my - ny) < n.r * 1.8) { found = n.id; break; }
    }
    hoveredRef.current = found;
    setHovered(found);
  }, [isOpen]);

  const handleClick = useCallback((e) => {
    if (!isOpen) return;
    const id = hoveredRef.current;
    if (!id) return;
    e.stopPropagation(); // évite de déclencher le listener "outside"
    const node = NODES.find(n => n.id === id);
    if (!node) return;
    if (node.id === 'contact') {
      onContactOpen?.();
    } else if (node.path) {
      onClose();
      navigate(node.path);
    }
  }, [isOpen, navigate, onClose, onContactOpen]);

  return (
    <div className={`atlas-overlay${isOpen ? ' open' : ''}`}>
      <canvas
        ref={cvRef}
        className="atlas-canvas"
        onMouseMove={handleMouseMove}
        onMouseLeave={() => { hoveredRef.current = null; setHovered(null); }}
        onClick={handleClick}
        style={{ cursor: hovered && isOpen ? 'pointer' : 'default' }}
      />
    </div>
  );
};

export default AtlasMenu;